module.exports = __webpack_public_path__ + "4df2a4cde8b131faa79f9264a431fa51.jpg";